// extracted by mini-css-extract-plugin
export default {"group":"InfoGroup_group__-DuO0","header":"InfoGroup_header__d337A","title":"InfoGroup_title__uLnEt"};